export default {
  description: null,
  references: [],
}
